import { type ComponentType } from 'react'
import { Card } from '@ui/base/card'

import { bodyText, container, lead, mutedText, sectionTitle } from './typography'

export type LandingBenefit = {
  /** Значок из набора lucide: страница передаёт сам компонент, набор здесь не фиксируется. */
  icon: ComponentType<{ className?: string; strokeWidth?: number; 'aria-hidden'?: boolean }>
  title: string
  text: string
}

/** Раздел выгод: карточки со значком на светлой подложке во всю ширину окна. */
export const LandingBenefits = ({
  id,
  intro,
  items,
  title,
}: {
  id: string
  intro: string
  items: LandingBenefit[]
  title: string
}) => (
  <section aria-labelledby={`${id}-title`} className="bg-secondary scroll-mt-20 border-y" id={id}>
    <div className={`${container} py-14 lg:py-20`}>
      <h2 id={`${id}-title`} className={sectionTitle}>
        {title}
      </h2>
      <p className={`${lead} ${mutedText} mt-2 mb-10 max-w-[62ch]`}>{intro}</p>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map(({ icon: Icon, text, title: benefitTitle }) => (
          <Card key={benefitTitle} className="gap-2.5 px-6 pt-6 pb-7">
            <span className="bg-primary/8 text-primary mb-1 flex size-10 items-center justify-center rounded-xl">
              <Icon aria-hidden className="size-5" strokeWidth={1.7} />
            </span>
            <h3 className="text-[19px] leading-[1.35] font-semibold tracking-[-0.012em] text-balance">
              {benefitTitle}
            </h3>
            <p className={`${bodyText} ${mutedText}`}>{text}</p>
          </Card>
        ))}
      </div>
    </div>
  </section>
)
